
import React from 'react';
import { Transaction } from '@/types/transaction';

interface TransactionIdInfoProps {
  transaction: Transaction;
}

const TransactionIdInfo: React.FC<TransactionIdInfoProps> = ({ transaction }) => {
  return (
    <div>
      <h3 className="text-sm font-medium text-muted-foreground mb-1">Transaction ID</h3>
      <p className="font-mono text-xs">{transaction.id}</p>
      {transaction.payment_intent_id && transaction.payment_intent_id !== transaction.id && (
        <p className="font-mono text-xs mt-1">Payment Intent: {transaction.payment_intent_id}</p>
      )}
    </div>
  );
};

export default TransactionIdInfo;
